import React from 'react';
import classnames from 'classnames';
import LoadingDots from 'components/LoadingDots';
import AppleIcon from 'components/icons/AppleIcon';
import ButtonError from './ButtonError';

const CSS = require('./AppleButton.less');

interface AppleButtonProps {
  children: string;
  onClick: () => void;
  isLoading?: boolean;
  error?: boolean;
  className?: string;
  [key: string]: any;
}

function AppleButton({ onClick, className, children, isLoading, error, ...rest }: AppleButtonProps) {
  const classes = classnames(CSS.AppleButton, {
    [className]: className,
  });

  return (
    <>
      <button className={classes} onClick={onClick} {...rest}>
        {isLoading ?
          <LoadingDots className={CSS.Loading} isWhite /> :
          <>
            <AppleIcon width={17} height={21} className={CSS.Icon}/>
            <span className={CSS.Children}>{children}</span>
          </>
        }
      </button>
      <ButtonError error={error} />
    </>
  );
}
export default AppleButton;
